module.exports = __webpack_public_path__ + "static/media/eyeSolid.a9d8c5e9.svg";